import { CClient, showErrorAlert } from '@common/utils'
import { CANCEL_REASONS } from '@lib/enums/dashboard'
import { flattenErrorsDictFromResponse } from '@lib/utils/common'
import { captureException } from '@sentry/node'
import { Dispatch, SetStateAction } from 'react'
import date from '@lib/utils/date.utils'
import { t } from '@lingui/macro'

type HandleRescheduleAtSelectedTimeOptionsType = {
  setInlineError: Dispatch<SetStateAction<string>>
  selectedDate: string
  selectedTime: string
  isLoading: boolean
  setIsLoading: Dispatch<SetStateAction<boolean>>
  classroomId: number | string
  onSuccess?: () => void
  isStudent?: boolean
  on404?: () => void
  isTeacher?: boolean
}

/** i18n support added */
export const handleReschdeuleAtSelectedTime = async ({
  setInlineError,
  selectedDate,
  selectedTime,
  isLoading,
  setIsLoading,
  classroomId,
  onSuccess,
  isStudent, // isStudent can also be true when a teacher reschedules a class from the teacher dashboard at the student's request.
  on404,
  isTeacher = false, // Will be true when triggered from teacher dashboard
}: HandleRescheduleAtSelectedTimeOptionsType) => {
  if (isLoading) return
  setInlineError('')
  if (!selectedDate || !selectedTime) {
    setInlineError('Please select both date and time for booking the class.')
    return
  }
  setIsLoading(true)
  try {
    const response = await CClient(
      `/api/v1/classrooms/${classroomId}/reschedule/`,
      {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },

        // TODO: Figure out how to send slotEventId of selected slot in payload
        body: JSON.stringify({
          start: selectedTime,
          cancelReason: isStudent
            ? CANCEL_REASONS.CANCEL_REQUEST_BY_STUDENT
            : CANCEL_REASONS.CANCEL_REQUEST_BY_TEACHER,
          cancelReasonOther: isTeacher
            ? 'rescheduled-from-teacher-dashboard'
            : '',
        }),
      }
    )
    if (response.ok) onSuccess?.()
    else if (response.status === 404) on404?.()
    else throw new Error(await flattenErrorsDictFromResponse(response))
  } catch (error) {
    captureException(error)
    showErrorAlert({
      text: isTeacher
        ? error.message
        : t({
            id: 'trialClass.rescheduleModal.errorMessage.generic',
            message:
              'Something went wrong while rescheduling your class. Please refresh the page and try again!',
          }),
    })
  }
  setIsLoading(false)
}

export const checkCanStudentRescheduleTrialClass = (startTime: string) =>
  date().isSameOrBefore(date(startTime).subtract(15, 'minutes'))
